import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import google_icon from 'assets/icons/google_icon.png';
import authApi from 'api/auth';
import { useAppDispatch, useAppTranslation } from 'app/hooks';
import { setLocalStorage } from 'utils/sessionStorage';
import { onChangeAuthPage } from 'features/home/homeSlice';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import useUserDetail from 'hooks/useUserDetail';

interface GoogleAuthProps {}

const GoogleAuth: React.FunctionComponent<GoogleAuthProps> = () => {
  const dispatch = useAppDispatch();
  const handleResponseError = useHandleResponseError();
  const { getUserDetail } = useUserDetail();
  const t = useAppTranslation();

  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (code) => {
      const { ok, error, body } = await authApi.googleLogin({ accessToken: code.code });
      if (ok && body) {
        setLocalStorage('access_token_terabet', body.accessToken);
        dispatch(onChangeAuthPage(-1));
      }
      if (error) {
        handleResponseError(error);
      }
      getUserDetail();
    },
    onError: (errorResponse) => console.log(errorResponse),
  });

  return (
    // <button onClick={() => googleLogin()} type="button" className="btn-sso">
    //   <img src={google_icon} alt="google" className="sso-logo" />
    //   <span>{t('login.sso.google')}</span>
    // </button>
    <img
      src={google_icon}
      alt="google"
      className="social-login-button"
      onClick={() => googleLogin()}
    />
  );
};

export default GoogleAuth;
